import { Constants } from "./constants";

export const UKC_AGILITY_STANDARD_BASE_SCORE = 200;
export const UKC_AGILITY_TOY_DIV1_ACT_BONUS_SECONDS = 5;
export const UKC_AGILITY_MINIMUM_HEIGHT_TIME_PENALTY_SECONDS = 5;

export type IUkcAgilitySctSource = {
  act_by_level?: { level: string; act: number }[];
  act?: number;
};

export const getUkcAgilityDivisionFromHeight = (heightAtWithers?: number): string => {
  if (heightAtWithers == null || Number.isNaN(heightAtWithers)) {
    return "";
  }

  if (heightAtWithers <= 10) {
    return Constants.dog_class_element.agility_division_toy;
  }
  if (heightAtWithers <= 14) {
    return Constants.dog_class_element.agility_division_1;
  }
  if (heightAtWithers <= 20) {
    return Constants.dog_class_element.agility_division_2;
  }
  return Constants.dog_class_element.agility_division_3;
};

export const getUkcAgilitySctSeconds = (
  show: IUkcAgilitySctSource | undefined,
  level?: string
): number => {
  if (!show) {
    return 0;
  }

  if (level && show.act_by_level?.length) {
    const levelConfig = show.act_by_level.find((entry) => entry.level === level);
    if (typeof levelConfig?.act === "number" && levelConfig.act > 0) {
      return levelConfig.act;
    }
  }

  return typeof show.act === "number" && show.act > 0 ? show.act : 0;
};

export const getUkcAgilityActSeconds = (sctSeconds: number, division: string): number => {
  if (!sctSeconds || sctSeconds <= 0) {
    return 0;
  }

  if (
    division === Constants.dog_class_element.agility_division_toy ||
    division === Constants.dog_class_element.agility_division_1
  ) {
    return sctSeconds + UKC_AGILITY_TOY_DIV1_ACT_BONUS_SECONDS;
  }

  return sctSeconds;
};

export const getUkcAgilityTimeFaults = (
  runTimeSeconds: number | undefined,
  actSeconds: number
): number => {
  if (
    actSeconds <= 0 ||
    runTimeSeconds == null ||
    Number.isNaN(runTimeSeconds)
  ) {
    return 0;
  }

  return Math.max(0, Math.round((runTimeSeconds - actSeconds) * 100) / 100);
};

export const getUkcAgilityStandardScore = (
  faults: number | undefined,
  timeFaults: number | undefined
): number => {
  return Math.max(
    0,
    Math.round(
      (UKC_AGILITY_STANDARD_BASE_SCORE - (faults || 0) - (timeFaults || 0)) * 100
    ) / 100
  );
};

/**
 * UKC ranks Minimum-height dogs as if 5 seconds were added to their run.
 * Recorded course time is unchanged; only HIT and class placement use this.
 */
export const getUkcAgilityComparisonTime = (
  runTimeSeconds: number | undefined,
  jumpHeightType?: string
): number => {
  if (runTimeSeconds == null || Number.isNaN(runTimeSeconds)) {
    return Number.POSITIVE_INFINITY;
  }

  if (jumpHeightType === Constants.jump_height_type.minimum) {
    return runTimeSeconds + UKC_AGILITY_MINIMUM_HEIGHT_TIME_PENALTY_SECONDS;
  }

  return runTimeSeconds;
};
